import { Menu } from "@headlessui/react";
import { ComponentType, MouseEventHandler } from "react";
import { Button } from "../../../components";

interface MenuDropdownItemProps {
  icon?: ComponentType<{ className?: string }>;
  text: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const MenuDropdownItem = ({
  icon,
  text,
  onClick
}: MenuDropdownItemProps) => (
  <Menu.Item>
    <Button icon={icon} text={text} onClick={onClick} />
  </Menu.Item>
);
